module.exports = __webpack_public_path__ + "img/stamp.92b639ca.svg";